<script setup lang="ts">
import { ref } from 'vue'
import axios from 'axios'
import Desktop from './Desktop.vue'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const props = defineProps<{
  token: string
}>()

const password = ref('')
const passwordConfirmation = ref('')
const loading = ref(false)
const message = ref('')
const error = ref('')

function csrfHeaders() {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  return {
    'X-CSRF-Token': token,
    Accept: 'application/json',
  }
}

async function submit() {
  message.value = ''
  error.value = ''

  if (password.value.length < 8) {
    error.value = 'Das Kennwort muss mindestens 8 Zeichen lang sein.'
    return
  }

  if (password.value !== passwordConfirmation.value) {
    error.value = 'Die Kennwörter stimmen nicht überein.'
    return
  }

  loading.value = true
  try {
    const response = await axios.patch('/password_resets.json', {
      token: props.token,
      password_reset: {
        password: password.value,
        password_confirmation: passwordConfirmation.value,
      },
    }, { headers: csrfHeaders() })

    message.value = response.data?.message || 'Kennwort wurde gesetzt.'
    window.setTimeout(() => {
      window.location.href = response.data?.redirect_url || '/login'
    }, 700)
  } catch (err: any) {
    error.value = err.response?.data?.error || 'Das Kennwort konnte nicht gesetzt werden.'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <Desktop>
    <div class="w-1/2 flex flex-col justify-top">
      <Card class="w-full max-w-sm hoeppner-bg">
        <CardHeader>
          <CardTitle class="text-center">Kennwort setzen</CardTitle>
        </CardHeader>
        <CardContent>
          <form class="space-y-4" @submit.prevent="submit">
            <div class="space-y-2">
              <Label for="new_password">Neues Kennwort</Label>
              <Input id="new_password" v-model="password" type="password" required minlength="8" autocomplete="new-password" />
            </div>

            <div class="space-y-2">
              <Label for="new_password_confirmation">Kennwort bestätigen</Label>
              <Input id="new_password_confirmation" v-model="passwordConfirmation" type="password" required minlength="8" autocomplete="new-password" />
            </div>

            <p v-if="message" class="text-sm text-green-700">{{ message }}</p>
            <p v-if="error" class="text-sm text-red-700">{{ error }}</p>

            <Button :disabled="loading" class="w-full greenbutton">
              {{ loading ? 'Speichern...' : 'Kennwort speichern' }}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  </Desktop>
</template>

<style scoped>
.hoeppner-bg {
  background-color: #F4F3F3 !important;
  border-radius: 0 !important;
}

.greenbutton {
  background-color: #80BA27 !important;
}
</style>
